import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import "scenes/ProductDetails/components/ProductSpecs/components/GeneralAccordion/styles/general-accordion.scss";
import SpecsTableColumn from "scenes/ProductDetails/components/ProductSpecs/components/SpecsTableRow/components/SpecsTableColumn";
import {
  cleanDataForCertificates,
  translateLabel,
} from "scenes/ProductDetails/components/ProductSpecs/components/SpecsTableRow/utils";
import useMediaQuery from "utils/hooks/useMediaQuery";
import CertificateLink from "./components/CertificateLink";
import ExpirationCertificate from "./components/ExpirationCertificate";
import MobileInfoRows from "./components/MobileInfoRows";
import TemperatureReduction from "./components/TemperatureReduction";
import "./styles/OtherAttributesAccordion.scss";
import { LG } from "constants/breakpoints";
import { calculateCertificateFileExpired, processOtherAttributesData } from "./utils";

const OtherAttributesAccordion = ({ data }) => {
  const isMobile = useMediaQuery(LG);
  const intl = useIntl();
  const finalData = processOtherAttributesData(data);
  const cleanedData = cleanDataForCertificates(finalData);
  const matchedCertificateString = "CertificateFile";

  return (
    <>
      {cleanedData.map((array, index) => {
        // Set new item for possible certificate and expired data
        array[2] = "";
        array[3] = "";
        
        if (array[0].indexOf("NotExpires") !== -1) return;
        if (array[0].indexOf(matchedCertificateString) !== -1) return;

        // Format array item value
        if (Array.isArray(array[1])) 
          array[1] = array[1].join("\n");
        
        if (
          finalData.hasOwnProperty(`${array[0]}${matchedCertificateString}`) ||
          array[0].indexOf("Method") === -1
        ) {
          const keyWithoutMethod = `${array[0]}${matchedCertificateString}`;
          const keyWithMethod = `${array[0]}Method${matchedCertificateString}`;

          if (array[0].indexOf("Method") === -1) {
            if (finalData[keyWithoutMethod] !== undefined && finalData[keyWithoutMethod] !== "") {
                array[3] = data.certificateDomain + finalData[keyWithoutMethod];
            } else if (finalData[keyWithMethod] !== undefined && finalData[keyWithMethod] !== "") {
                array[3] = data.certificateDomain + finalData[keyWithMethod];
            }
          }
        }

        // Validation to calculate expires certificates
        if (array[3] !== "") {
          const expiresValue = finalData[`${array[0]}${matchedCertificateString}Expires`]
          const notExpiresValue = finalData[`${array[0]}NotExpires`]

          if (expiresValue || notExpiresValue) {
            const resultExpiresValue = calculateCertificateFileExpired(expiresValue, notExpiresValue);
            array[2] = <ExpirationCertificate expiredData={resultExpiresValue} onlyCircleWithoutText={isMobile} />
          }
        }

        // Translate item title
        array[0] = translateLabel(array[0], intl);
        return !isMobile ? (
            <tr key={index} className="other-attributes__row">
              {array.map((item, index) => {
                return <td key={index}>
                  {index === 3 ? (
                    <SpecsTableColumn value={<CertificateLink link={item} />} />
                  ) : (
                    <SpecsTableColumn value={item} />
                  )}
                </td>
              })}
            </tr>
          ) : <MobileInfoRows currentItemInfo={array} />
      })}
      {data.temperatureReductionTreatment && (
        <TemperatureReduction data={data} />
      )}
    </>
  );
};

OtherAttributesAccordion.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      technical_limitations: PropTypes.string,
    })
  ).isRequired,
};

export default OtherAttributesAccordion;
